module.exports = __webpack_public_path__ + "static/media/(LH)_MG_5931_-_bijuterias.78c72d7a.jpg";